
import React, { useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import * as R from 'ramda';

import { setProducerName, setParticipantInProducer, toggleProducerMenu, toggleProducerMuted, toggleProducerSpotted } from '../redux/producers/producersActions';
import { ADD_PRODUCER, REMOVE_PRODUCER, SET_NAME_AND_URL_PRODUCER, SET_NAME_PRODUCER, SET_PRODUCERS } from '../redux/producers/producersReducer';
import { MEETING_SET_RECEIVING_CONTENT, MEETING_SET_RECEIVING_VIDEOID, MEETING_SET_SHARING_CONTENT, MEETING_UPDATE_FROM_SDK } from '../redux/meeting/meetingReducer';

import { Config } from '../config';

import "./producersList.scss";

import { ApiService } from '../services/api-service';
import { container } from 'tsyringe';
import { getInitials, useSharedState, uuidv4 } from '../utils/helpers';
import ProducerCard from './producerPlayer/ProducerCard';
import { Producer, ProducerType } from '../models/producerClass';

import { ActionType, GroupType } from '../models/actionClass';

import { SoundKey, SoundService } from '../services/sound-service';
import { WebRTCsdkService } from '../services/webrtcsdk-service';
import { PTSocketService } from '../services/ptsocket.service';
import { PTApiService } from '../services/ptapi-service';
import { PeopleKind, PeopleService } from '../services/people-service';

import { MeetingStore, SharingState } from '../models/meetingClass';
import { SettingService, SettingsKey } from '../services/setting-service';
import { People } from '../models/peopleClass';
import { profile } from 'console';

interface ProducerProps {
  producer: Producer;
  onToggleLive: any;
  onToggleSpotted: any;
  onSetName: any;
}

const setVideoStream = (producer: Producer) => {
        // once video div is created , we can establish stream asso
        if (producer.url.indexOf('webrtc') >= 0) {

          let div = null;
          let video = null;

          if (producer.url.indexOf('webrtc-content-remote')>=0) {
            // content share
            div = document.getElementById('card-' + producer.url);
            video = document.getElementById(producer.url.indexOf('local')>0 ? 'localcontentvideo' : 'remotecontentvideo');
          } else if (producer.streamIndex === 0) {
            // local producer
            div = document.getElementById('card-' + producer.url);
            video = document.getElementById('localvideo');
          } else if (producer.streamIndex > 0) {
            div = document.getElementById('card-' + producer.url);
            video = document.getElementById('remotevideo' + ('0'+(producer.streamIndex -1)).slice(-2));
          }
          if (div && video && video.srcObject && div?.srcObject !== video.srcObject) {
            div.srcObject = video.srcObject;
          }
        }
}
const ProducerItem = ({producer, onToggleLive, onToggleSpotted,  onSetName }: ProducerProps) => {

  useEffect(() => {

    setTimeout(() => {
      setVideoStream(producer);
    }, 500);

    setTimeout(() => {
      setVideoStream(producer);
    }, 1000);

  }, [producer]);


  return (
    <ProducerCard producer={producer}
      id={producer.id}
      name={producer.name}
      isSelf={producer.isSelf}
      isLive={producer.isLive}
      isSpotted={producer.isSpotted}
      isMenuOpened={producer.isMenuOpened}
      audioMute={producer.audioMute}
      callQuality={producer.callQuality}
      videoMute={producer.videoMute}
      initials={getInitials(producer.name)}
      speaking={producer.speaking}
      camera={producer.camera}

      onToggleLive={(isLive) => onToggleLive({producer, isLive})}
      onToggleSpotted={(isSpotted) => onToggleSpotted({producer, isSpotted})}
      onSetName={(name) => onSetName({producer, name})}
      />
    );

};


interface LiveProducerListProps {
  producers: Producer[];
}
export const LiveProducerList = ({producers}: LiveProducerListProps) => {

  return <ul className="producer-list">
  {
    producers.map((producer, index) =>
      <li key={producer.id}>{producer.url}</li>
    )
  }
  </ul>;
};

interface ProducerListProps {
  producers: Producer[];
  onToggleLive: any;
  onToggleSpotted: any;
  onSetName: any;
}

const sortOnOrderRank = (a,b) => {
  return a.orderRank - b.orderRank;
  // if (a.orderRank < b.orderRank) return -1;
  // if (a.orderRank > b.orderRank) return 1;
  // return 0;
}


const swapNumbers = (p, pp) => {
  const temp = p.number;
  p.number = pp.number;
  pp.number = temp;
}
const swapRanks = (p, pp) => {
  const temp = p.orderRank;
  p.orderRank = pp.orderRank;
  pp.orderRank = temp;
}

const checkIfSwapNeeded = (prods, apiService) => {

  const liveprods = prods.filter(p=>p.number>0);

  // check if first producer has lower layer number
  if (liveprods.length>=2) {

    let min =  Number.MAX_SAFE_INTEGER;
    let minProd = null;
    for (const prod of liveprods) {
      if (prod.number < min) {
        min = prod.number;
        minProd = prod;
      }
    }

    if (liveprods[0].number > minProd.number) {
      // swap prod[0] and nimProd
      swapNumbers(liveprods[0], minProd);
      apiService.swapLayers([liveprods[0].number, minProd.number]);
    }
  }
}



export const ProducerList = ({producers, onToggleLive, onToggleSpotted,  onSetName}: ProducerListProps) => {

  const dispatch = useDispatch();

  const [apiService] = useState(container.resolve(ApiService));

  let draggedProducer = producers[0];
  let droppedProducer = producers[0];


  const OnDragOver = (ev, producer) => {
    if (ev) {
      ev.preventDefault();
    }
    if (producer && producer.id !== draggedProducer.id) {
      // set border to dest producer
      clearDroppedProducer();
      droppedProducer = producer;
      const li = document.getElementById('card'+droppedProducer.id);
      if (li) {
        // li.style.setProperty('margin-left', '30px');
        li.style.setProperty('transform', 'scale(0.9)');
      }
    }
  }

  const clearDroppedProducer = () => {
    if (droppedProducer) {
      const li = document.getElementById('card'+droppedProducer.id);
      if (li) {
        // li.style.setProperty('margin-left', '0px');
        // li.style.setProperty('border', 'none');
        li.style.setProperty('transform', 'scale(1.0)');
      }
    }
  }

  const OnDragStart = (ev, producer) => {
    // if (ev) {
    //   ev.preventDefault();
    // }
    if (producer.url !== '') {
      draggedProducer = producer;
      droppedProducer = producer;
      console.log('dragStart', producer.name);
    } else {
      draggedProducer = null;
      droppedProducer = null;
    }
  }

  const OnDragEnd = (ev) => {
    clearDroppedProducer();
  };
  const OnDragLeave = (ev) => {
    clearDroppedProducer();
  }

  const reoderProducer = R.clone(producers);

  const OnDrop = (ev, onProducer) => {

    const p1 = reoderProducer.find(p => p.id === draggedProducer.id);
    const p2 = reoderProducer.find(p => p.id === onProducer.id);

    if (p1 && p2) {

    //   const swappedLayers = [];

    //   console.log('ORDER drop done: reorder ', p1.name, ' onto ', p2.name);

    //   if (p1.orderRank !== p2.orderRank) {

    //     if (p1.orderRank > p2.orderRank) {
    //       while (p1.orderRank > p2.orderRank) {
    //         // find max prod with orderRank < p1.orderRank
    //         const prev = reoderProducer.find(p => p.orderRank === (p1.orderRank - 10));
    //         if (prev) {
    //           console.log('ORDER found prev=', prev.orderRank, prev.name);
    //           if (p1.isLive && prev.isLive) {
    //             if (p1.liveRank > prev.liveRank) {
    //               //  swap p1 and prev in caspar
    //               console.log('ORDER swap number', p1.number, prev.number);
    //               swappedLayers.push(p1.number, prev.number)
    //               swapNumbers(p1, prev);
    //             }
    //           }
    //           console.log('ORDER swap rank=', p1.orderRank, prev.orderRank);
    //           swapRanks(p1, prev);
    //         }
    //       }
    //     }
    //     else if (p1.orderRank < p2.orderRank) {
    //       while (p1.orderRank < p2.orderRank) {
    //         // find max prod with orderRank < p1.orderRank
    //         const next = reoderProducer.find(p => p.orderRank === (p1.orderRank + 10));
    //         if (next) {
    //           console.log('ORDER found next=', next.orderRank, next.name);
    //           if (p1.isLive && next.isLive) {
    //             if (p1.liveRank < next.liveRank) {
    //               //  swap p1 and next in caspar
    //               console.log('ORDER swap number', p1.number, next.number);
    //               swappedLayers.push(p1.number, next.number)
    //               swapNumbers(p1, next);
    //             }
    //           }
    //           console.log('ORDER swap rank=', p1.orderRank, next.orderRank);
    //           swapRanks(p1, next);
    //         }
    //       }
    //     }

    //     // sort by order
    //     reoderProducer.sort(sortOnOrderRank);
    //     reoderProducer.forEach( p => p.liveRank = p.orderRank);

    //   }


    //   console.log('ORDER' , reoderProducer.map(p => p.orderRank));

    //   apiService.swapLayers(swappedLayers);

    //   // dispatch producers
    //   apiService.updateReason = {group: GroupType.PRODUCER, action: ActionType.REORDER};
    //   dispatch( { type: SET_PRODUCERS, payload: reoderProducer});
    // }

      if (p1.orderRank > p2.orderRank) {
        p1.orderRank = p2.orderRank - 1;

      } else {
        if (p2.orderRank === Number.MAX_SAFE_INTEGER) {
          p1.orderRank = Number.MAX_SAFE_INTEGER - 1;
        } else {
          p1.orderRank = p2.orderRank + 1;
        }
      }

      // sort by order
      reoderProducer.sort(sortOnOrderRank);

      // renum order
      let order = 10;
      let number = 1;
      reoderProducer.forEach( p => {
        p.orderRank = (p.url !== '' ? order : Number.MAX_SAFE_INTEGER);
        if (p.url !== ''  && p.liveRank !== 0) {
          p.liveRank = order;
          // if (p.isLive) {
          //   p.number = number++;
          // } else {
          //   p.number = 0;
          // }
        }
        order += 10;
      });

      checkIfSwapNeeded(reoderProducer, apiService);

      // dispatch producers
      dispatch( { type: SET_PRODUCERS, payload: reoderProducer});

      apiService.producerOrderSet$.next(reoderProducer);
      apiService.updateReason = {group: GroupType.PRODUCER, action: ActionType.REORDER};
      apiService.saveChannel('reoder_prod');

    }

    clearDroppedProducer();
  };


    return <ul  className="producer-list" style={{listStyle: 'none', paddingLeft: 0}}>
    {
      producers.map((producer, index) =>
        <li key={producer.id}  id={'producer' + index + 'REF'} style={{position: "relative", zIndex: 1}}
          draggable
          onDragOver={(e) => OnDragOver(e, producer)}
          onDragStart={(e) => OnDragStart(e, producer)}
          onDragEnd={(e) => OnDragEnd(e)}
          onDragLeave={(e) => OnDragLeave(e)}
          onDrop={(e) => OnDrop(e, producer)}
        >
          <div id={'card'+producer.id} style={{transition: 'transform 200ms'}}>
            <ProducerItem producer={producer} onToggleLive={onToggleLive} onToggleSpotted={onToggleSpotted}
            onSetName={onSetName} key={producer.id}></ProducerItem>
          </div>
        </li>
      )
    }
  </ul>;
};


export const ProducerListStore = () => {

  const [apiService] = useState(container.resolve(ApiService));
  const [soundService] = useState(container.resolve(SoundService));
  const [ptSocketService] = useState(container.resolve(PTSocketService));
  const [ptApiService] = useState(container.resolve(PTApiService));
  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));
  const [settingService] = useState(container.resolve(SettingService));
  const [peopleService] = useState(container.resolve(PeopleService));

  const meetingStore: MeetingStore = useSelector((state: any) => state.meetingStore);

  const [peoples] = useSharedState(peopleService.peoples$);
  const [meetingState] = useSharedState(webRTCsdkService.meetingState$);

  const [orders] = useSharedState(apiService.producerOrder$);
  const [spottedProducer, setSpottedProducer] = useSharedState(apiService.spottedProducer$);

  const producers = useSelector((state: any) => state.producers);

  const [autoToggleLive, setAutoToggleLive] = useState(null);
  const [autoToggleMySelf, setAutoToggleMySelf] = useState(true);
  const dispatch = useDispatch();



  const getName = (participant) => {
    if (!participant || !participant.name) return undefined;
    // if (participant.isSelf) {
    //   return 'Self';
    // }
    return participant.name;
  }


  const onToggleLive = (payload) => {
    console.log('onToggle callback', payload);

    // find producer in producers
    const prods = R.clone(producers);
    const prod = prods.find(p => p.id === payload.producer.id);
    if (prod) {

      if (payload.isLive) {
        // allocate liveRank
        const liveRanks = prods?.filter(p => p.isLive).map(p => p.liveRank) || [0];
        prod.isLive = true;

        if (prod.number === 0) {
          // find free number for this producer
          const numbers = prods?.map(p => p.number) || [0];
          prod.number = Math.max(1, ...numbers) + 1;

          if (prod.type === ProducerType.CONTENT_SHARING) {
            prods.forEach(p => {
                // shift already live prod to the right
                if (p.id !== prod.id && p.url !== '' && p.liveRank > 0) {
                    p.liveRank += 10;
                    p.updatedCounter += 1;
                }
            });
            prod.liveRank = 10;
          } else {
              // find free number for this producer (minimum is 2 - 0 is for background - 1 is for ContentSharing)
              prod.liveRank = (1 * Math.max(0, ...liveRanks)) + 10;
          }

        } else {
          // already have a layer number  =>  just put in live
          console.log('producer has already a layer number before going live: CHECK', prod);
        }
        soundService.playSoundStart(SoundKey.GuestBackstage);
      } else {
        prod.number = 0;
        prod.liveRank = 0;
        prod.isLive = false;
        prod.isSpotted = false;
      }

      checkIfSwapNeeded(prods, apiService);

      // dispatch producers
      dispatch( { type: SET_PRODUCERS, payload: prods});
      apiService.producerOrderSet$.next(prods);

      apiService.updateReason = {group: GroupType.PRODUCER, action: ActionType.TOGGLE_LIVE, id: payload};
      apiService.saveChannel('toggle_live');
    }

  }

  const onToggleSpotted = (payload) => {
    console.log('onToggleSpotted callback', payload);
    setSpottedProducer(payload);

  }

  const onSetName = (payload) => {
    console.log('onSetName callback', payload);
    if (payload.name && payload.name.length > 0) {

      // call ptapi to warn Event meeting
      // ptApiService.renameParticipantByGuid(payload.name, payload.producer.peopleGuid);
      peopleService.renameParticipantByGuid(payload.name, payload.producer.peopleGuid);
    } else {
      // reset producer name
    }

  }

  useEffect(() => {
    if (spottedProducer) {
      const prods = R.clone(producers);
      const prod = prods.find(p => p.id === spottedProducer.producer.id);
      if (prod) {
        for (const p of prods) {
          // reset flag for others
          p.isSpotted = false;
        }
        prod.isSpotted = spottedProducer.isSpotted;
        dispatch( { type: SET_PRODUCERS, payload: prods});
        apiService.producerOrderSet$.next(prods);

        apiService.updateReason = {group: GroupType.PRODUCER, action: ActionType.TOGGLE_SPOTTED, id: spottedProducer.producer.id};
        apiService.saveChannel('toggle_spotted');
      }

    }
  }, [spottedProducer]);


  useEffect(() => {

    let mproducers = R.clone(producers);

    if (mproducers.length === 0) return;

    const realPeoples: People[] = peoples.filter(p => p.inParticipantRoster && p.role !== PeopleKind.ATTENDEE);

    let currentCSPresenter = null;
    let selfGuid = null;
    let producer = null;
    let shmUrl = '';
    let url = '';
    for(const people of realPeoples) {
      try {
        console.log('==PROD people=', people.name, people.streamIndex, people.shareScreen)
        // if (people.isSelf) {
        //   selfGuid = people.id;
        //   // assign to first producer
        //   producer = mproducers.find(p => p.streamIndex === 0);
        //   if (!producer) {
        //     producer = mproducers[0];
        //   }

        //   if (producer.url !== 'webrtc00') {
        //     console.log('GIC error')
        //   }
        //   if (people.videoMute) {
        //     shmUrl = Config.BACKEND_API_URL + '/nametag/generate?initials=' + getInitials(people.name);
        //   }
        // } else {

          // find producer with same Guid
          producer = mproducers.find(p => p.participantGuid === people.seamGuid);

          if (!producer) {
              // find a 'free' producer
            console.log('==PROD find free for ', people.name, people.streamIndex, people.csrc);
            producer = mproducers.find(p => p.url === '');

            const orderRanks = mproducers.filter(p => p.url !== '').map(p => p.orderRank);
            const newOrderRank = ( 1 * R.reduce(R.max, 0, orderRanks)) + 10;


            producer.orderRank = newOrderRank;
          }


        // }

        if (producer) {

          shmUrl =  'csrc://' + people.csrc;
          if (people.videoMute) {
            shmUrl = Config.BACKEND_API_URL + '/nametag/generate?initials=' + getInitials(people.name);
          }

          producer.name = people.name;
          producer.streamIndex = people.streamIndex;
          producer.url = people.videoMute ? shmUrl : people.url;
          producer.callQuality = people.callQuality;
          producer.participantGuid = people.seamGuid;
          producer.peopleGuid = people.id
          producer.audioMute = people.audioMute;
          producer.videoMute = people.videoMute;
          producer.speaking = people.speaking;
          producer.csrc = isNaN(people.csrc) ? 0: people.csrc;
          producer.isLive = producer.isLive;
          producer.isSpotted = producer.isSpotted;
          producer.shmUrl = shmUrl;
          producer.camera = people.camera;
          producer.blurRange = people.blurRange;

          console.log('==PROD', producer, people);
        }

        if (autoToggleMySelf && people.isSelf) {
          setAutoToggleMySelf(false);
          setAutoToggleLive({isLive: true, producer});
        }

        // check if this people is sharing content
        if (people.shareScreen) {



          // save current presenter
          currentCSPresenter = people;
          if (meetingStore.currentVideoId === '') {
            // console.log('SHARE found CS presenter SET_RECEIVING_VIDEOID', {
            // videoId: 'screenshare',
            // })
            dispatch({type: MEETING_SET_RECEIVING_VIDEOID, payload: {
              videoId: 'screenshare',
            }});
          }
          // console.log('SHARE found CS presenter SET_RECEIVING_CONTENT ', {
          //   receivingContent: true,
          //   presenterName: people.name,
          //   presenterGuid: people.seamGuid,
          // })
          dispatch({type: MEETING_SET_RECEIVING_CONTENT, payload: {
            receivingContent: true,
            presenterName: people.name,
            presenterGuid: people.seamGuid,
          }});
        }

      } catch (e) {
        console.log('GIC error while processing meeting participants', e);
      }
    }


    if (!currentCSPresenter && meetingStore.receivingContent) {
      // nobody showing content -> set meeting state

      // console.log('SHARE NO CS presenter  SET_RECEIVING_CONTENT ', {
      //   receivingContent: false,
      //   presenterName: '',
      //   presenterGuid: '',
      // })

      dispatch({type: MEETING_SET_RECEIVING_CONTENT, payload:{
          receivingContent: false,
          presenterName: '',
          presenterGuid: ''
        }
      });

      // console.log('SHARE NO CS presenter SET_RECEIVING_VIDEOID', {
      //   videoId: '',
      // })

      dispatch({type: MEETING_SET_RECEIVING_VIDEOID, payload: {
        videoId: '',
      }});
    }

    // get current CSproducer
    let CSproducer = mproducers.find(p => p.url.indexOf('webrtc-content-remote')>=0 || p.url.indexOf('showing-local-content')>=0);

    if (currentCSPresenter && (meetingStore.currentVideoId === '' ||  meetingStore.currentVideoId === 'screenshare') ){
      // add contentShare producer is not already set and not receiving a video
      console.log('CURRENT VIDEO' , meetingStore.currentVideoId);

      let nextRank = 50000;  // anything bigger than number of not empty producer * 100
      if (!CSproducer ) {
        // create a CS producer and ADD
        const CSproducerName = currentCSPresenter  ? getName(currentCSPresenter) + "'s Screen" : 'Content Sharing Screen';
        const url = currentCSPresenter.isSelf ? 'showing-local-content' : 'webrtc-content-remote';
        CSproducer = new Producer(url, CSproducerName, uuidv4(), 0, 'America/New_York', 99);
        CSproducer.orderRank =  nextRank;
        CSproducer.liveRank = nextRank;
        CSproducer.streamIndex = 0;
        CSproducer.type = ProducerType.CONTENT_SHARING;
        CSproducer.videoMute = false;

        if (settingService.getSetting(SettingsKey.automaticAddStreamSharedScreen)) {
          setAutoToggleLive({isLive: true, producer: CSproducer});
          // setTimeout(() => {
          //   // call toggleLive after CS is displayed
          //   onToggleLive({isLive: true, producer: CSproducer});
          // }, 500);  // TODO check if 500ms is enough
        }

        dispatch({type: ADD_PRODUCER, payload: CSproducer});
      } else if (CSproducer.name !== getName(currentCSPresenter)) {
        // change producer name and URL
        dispatch({type: SET_NAME_AND_URL_PRODUCER, payload: {
          producer: CSproducer,
          name: getName(currentCSPresenter) + "'s Screen",
          url: currentCSPresenter.isSelf ? 'showing-local-content' : 'webrtc-content-remote',
          shmUrl: 'csrc://0',
        }});
      }

    } else if (CSproducer) {
      // no more CSpresenter => remove CSproducer
      mproducers = mproducers.filter(p => p.id !== CSproducer.id);
    }

    // remove producer when participant hangup or CS ended
    let producerHasBeenRemoved = false;
    let removedProducerRank = Number.MAX_SAFE_INTEGER;

    for (const producer of mproducers.filter(p => p.participantGuid !== '' && p.streamIndex !== 0)) {

      // find people
      let people = realPeoples.find(p => p.id ===  producer.peopleGuid);
      if (!people) {
        // clear producer
        console.log('==PROD remove', producer.name, producer.streamIndex, producer.csrc, producer.orderRank);
        removedProducerRank = producer.orderRank;
        producer.url = '';
        producer.shmUrl = '';
        producer.name = '';
        producer.streamIndex = -1;
        producer.participantGuid = '';
        producer.audioMute = false;
        producer.videoMute = false;
        producer.isLive = false;
        producer.isSpotted = false;
        producer.orderRank = Number.MAX_SAFE_INTEGER;
        producer.liveRank = Number.MAX_SAFE_INTEGER;
        producer.number = 0;
        // add a new producer at the end
        producerHasBeenRemoved = true;
      }
    }


    if (!R.equals(mproducers, producers)) {

      apiService.updateReason = {group: GroupType.PRODUCER, action: ActionType.PEOPLE_UPDATE};

      if (producerHasBeenRemoved) {

        mproducers.sort(sortOnOrderRank);

        mproducers.forEach( p => {
          if (p.url !== '' && p.orderRank !== Number.MAX_SAFE_INTEGER) {
            if (p.orderRank > removedProducerRank) {
              p.orderRank -= 10;
            }
            if (p.liveRank > removedProducerRank) {
              p.liveRank -= 10;
            }
          }
        });
      }

      // dispatch producers
      dispatch( { type: SET_PRODUCERS, payload: mproducers});
      apiService.producerOrderSet$.next(mproducers);

      apiService.saveChannel('peoples updated');

    }

  }, [peoples]);


  useEffect(() => {
    console.log('meeting state', meetingState);

    const myself = peopleService.getMySelf();

    if (meetingStore.videoMute !== meetingState.videoMute ||
      meetingStore.audioMute !== meetingState.audioMute ||
      meetingStore.receivingContent !== meetingState.receivingContent ||
      meetingStore.connexionState !== meetingState.connexionState) {
      dispatch({ type: MEETING_UPDATE_FROM_SDK, payload: { ...meetingState } });
    }

    if (meetingStore.receivingContent !== meetingState.receivingContent && !meetingState.receivingContent) {
      // reset presenter name and guid
      dispatch({ type: MEETING_SET_RECEIVING_CONTENT, payload: { receivingContent: false, presenterName: '', presenterGuid: '' } });
    }

    if (meetingStore.sharingLocalContent !== meetingState.sharingLocalContent) {

      if (meetingState.sharingLocalContent === 'stopped' ||
        meetingState.sharingLocalContent === 'canceled' ||
        typeof (meetingState.sharingLocalContent) === 'undefined' ||
        meetingState.sharingLocalContent === null) {

        if (meetingStore.currentVideoId === '' || meetingStore.currentVideoId === 'screenshare') {
          // nothing shared
          dispatch({ type: MEETING_SET_SHARING_CONTENT, payload: { sharingContent: false, sharingLocalContent: SharingState.NONE } });
        } else {
          if (meetingStore.presenterGuid === myself?.seamGuid) {
            dispatch({ type: MEETING_SET_SHARING_CONTENT, payload: { sharingContent: true, sharingLocalContent: SharingState.VIDEO } });
          } else {
            console.log('meeting state: receiving video not from myself', meetingStore.presenterGuid, meetingState.presenterName);
            dispatch({ type: MEETING_SET_SHARING_CONTENT, payload: { sharingContent: false, sharingLocalContent: SharingState.NONE } });
          }
        }
      } else {
        // sharing a screen
        dispatch({ type: MEETING_SET_SHARING_CONTENT, payload: { sharingContent: true, sharingLocalContent: SharingState.SCREEN } });
      }
    }

  }, [meetingState])

  useEffect( () => {
    console.log('PROD order from get channel API', orders);

    if (orders && orders.length > 0) {

      let doDispatch = false;
      const prods = R.clone(producers);
      for(const producer of prods) {
        if (producer.url !== '') {
          // find this producer in layerlist
          const order = orders.find(p => p.participantGuid === producer.participantGuid);
          if (!order) {
            // this producer has no order info ...
            // TODO remove this producer (no more connected on Event or deleted by moderator...)
            if (producer.isLive) {
              // // and is still live -> remove it
              // producer.isLive = false;
              // producer.isSpotted = false;
              // producer.liveRank = 0;
              // producer.orderRank = Number.MAX_SAFE_INTEGER - removedRank;
              // producer.number = 0;
              // doDispatch = true;
            }
          } else {
            if (producer.isLive && !order.isLive) {
              // and is still live -> offlive it
              producer.isLive = false;
              producer.isSpotted = false;
              producer.liveRank = order.liveRank;
              producer.orderRank = order.orderRank;
              producer.number = 0;
              doDispatch = true;
            }
            if (!producer.isLive && order.isLive) {
              // and is not live -> add it
              producer.isLive = true;
              producer.isSpotted = false;
              producer.liveRank = order.liveRank;
              producer.orderRank = order.orderRank;
              producer.number = order.number || 0;
              doDispatch = true;
            }
            if (producer.isSpotted !== order.isSpotted) {
              // and is not spotted -> spot him
              producer.isSpotted = order.isSpotted;
              if (producer.isSpotted) {
                prods.map(p => {if (p.id !== producer.id) p.isHidden = true});
              }
              doDispatch = true;
            }
            if (producer.liveRank !== order.liveRank) {
              // and moved
              producer.number = order.number || 0;
              producer.liveRank = order.liveRank;
              producer.orderRank = order.orderRank;
              doDispatch = true;
            }
            else if (producer.orderRank !== order.orderRank) {
              // and swapped
              producer.number = order.number || 0;
              producer.liveRank = order.orderRank;
              producer.orderRank = order.orderRank;
              doDispatch = true;
            }
          }
        }
      }
      // for(const order of orders) {
      //   // check if this is a new producer
      //   const prod = prods.find(p => p.id === order.id);
      //   if (!prod) {
      //     // add a new producer
      //     const newprod = new Producer(order.url, order.name, order.id, order.number, order.timezone, order.streamIndex);
      //     newprod.isLive = order.isLive;
      //     newprod.isSpotted = order.isLive;
      //     newprod.liveRank = order.liveRank;
      //     newprod.orderRank = order.orderRank;
      //     newprod.callQuality = order.callQuality;
      //     prods.push(newprod);
      //   }
      // }

      if (doDispatch) {
        prods.sort(sortOnOrderRank);
        // dispatch cloned prods
        dispatch( { type: SET_PRODUCERS, payload: prods});
        apiService.producerOrderSet$.next(prods);
        // producersRef.current = prods;
      }
    }

  }, [orders]);

  useEffect(()=> {

    // asynchronous method : check autoToggleLive state to be able to call onToggleLive
    // after the array producers has been updated by redux

    if (autoToggleLive) {
      const prod = producers.find(p => p.id === autoToggleLive.producer.id);
      if (prod) {
        onToggleLive(autoToggleLive);
        setAutoToggleLive(null);
      }
    }
  }, [producers])

  // useEffect(() => {
  //   console.log('PRODUCERS', producers);
  //   producers.filter(p => p.url.length>0).map(p => {
  //     console.log('SET producerOrder$',  p.name + '-' + p.orderRank + '-' + p.liveRank + '-' + p.number );
  //   });
  //   apiService.producerOrderSet$.next(producers.filter(p => p.url.length>0));
  // }, [])

  return <ProducerList producers={producers} onToggleLive={onToggleLive} onToggleSpotted={onToggleSpotted}  onSetName={onSetName}></ProducerList>;
};


